export default __webpack_public_path__ + "static/media/jQuery.fee8cc91.png";